'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _listing = require('./components/listing');

var _listing2 = _interopRequireDefault(_listing);

var _add = require('./components/add');

var _add2 = _interopRequireDefault(_add);

var _edit = require('./components/edit');

var _edit2 = _interopRequireDefault(_edit);

var _coupon = require('./components/coupon.config');

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _coupon2 = require('./services/coupon.service');

var _coupon3 = _interopRequireDefault(_coupon2);

var _couponDataprovider = require('./services/coupon.dataprovider.service');

var _couponDataprovider2 = _interopRequireDefault(_couponDataprovider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('coupons', [_angularUiRouter2.default]).component('couponsListing', _listing2.default).component('couponsAdd', _add2.default).component('couponsEdit', _edit2.default).service('Coupons', _coupon3.default).service('CouponsDataProvider', _couponDataprovider2.default).config(_coupon.CouponConfig).name;

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/modules/coupons/index.js
 **/